import { AllowedProductNames } from "./components/types";

// Basic:
// max number of conversations: 10
// max number of edits per conversation: 10
// max generated tokens per conversation: 50k
// max overall generated tokens: 150k
// Pro:
// max number of conversations: 100
// max number of edits per conversation: 50
// max generated tokens per conversation: 125k
// max overall generated tokens: 375k
// Enterprise:
// max number of conversations: unlimited
// max number of edits per conversation: unlimited
// max generated tokens per conversation: unlimited
// max overall generated tokens: unlimited

export const PRODUCTS_CONFIG = {
  NEXBOT: {
    id: "nexbot",
    name: "Nexbot",
    appCode: "lemmughvsxbfl3vnsxo",
    baseUrl: "https://nexbot-ai.com/",
    icon: "Bot",
    iconColor: "blue",
    description:
      "Nexbot is a cognitive assistant that helps a user design the architecture for an infrastructure hosted in a Cloud scenario. It can design diagrams for both Google Cloud, AWS and Azure, and can also combine services from different providers to generate hybrid solutions. While fulfilling the user's request with a diagram, it also analyzes the output itself for errors or improvements to the infrastructure. Once the user finishes creating the diagram, it can also generate a PDF file with the cost associated with the infrastructure and some Terraform files to deploy the infrastructure itself. Nexbot can also scan a GCP project and generate a diagram based on it. Last but not least, Nexbot is also able to migrate services from one cloud provider to another (for the current version, only VM migration is enabled)",
    features: [],
    featuresTire: [
      {
        name: "max number of conversations: 10",
        included: true,
        isBasic: true,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "max number of edits per conversation: 10",
        included: true,
        isBasic: true,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "max generated tokens per conversation: 50k",
        included: false,
        isBasic: false,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "max overall generated tokens: 150k",
        included: false,
        isBasic: false,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "Access to the chatbot",
        included: false,
        isBasic: true,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "Support with ticket",
        included: false,
        isBasic: true,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "Direct and personalized support",
        included: false,
        isBasic: false,
        isPro: false,
        isEnterprise: true,
      },
    ],
    tierFeatures: {
      Basic: [
        "Access to the chatbot",
        "Support with ticket",
        "max number of conversations: 10",
        "max number of edits per conversation: 10",
        "max generated tokens per conversation: 50k",
        "max overall generated tokens: 150k",
      ],
      Pro: [
        "Access to the chatbot",
        "Support with ticket",
        "max number of conversations: 100",
        "max number of edits per conversation: 50",
        "max generated tokens per conversation: 125000",
        "maxOverallGeneratedTokens: 375000",
      ],
      Enterprise: [
        "Access to the chatbot",
        "Support with ticket",
        "Direct and personalized support",
        "max number of conversations: Unlimited",
        "max number of edits per conversation: Unlimited",
        "max generated tokens per conversation: Unlimited",
        "max overall generated tokens: Unlimited",
      ],
    },
    pricing: {
      Basic: 9.99,
      Pro: 19.99,
      Enterprise: "Personal agreement",
    },
  },
  NEXCODE: {
    id: "nexcode",
    name: "Nexcode",
    appCode: "4x21jZmnA0TNzZfA3i3l",
    baseUrl: "http://dialogflowappserver.nexum.srl:4000/",
    icon: "Code",
    iconColor: "purple",
    description:
      "Nexcode is a cognitive assistant that enables the user to: Create and customize components in a React application, add methods and functionalities to them, change application libraries by simply chat with it.Create and customize SpringBoot applications via swaggers or direct requests using the assistant. Automatically containerize and deploy the microservice or the whole application on Cloud Run.",
    features: [
      "React component creation",
      "SpringBoot API development",
      "Automated containerization",
      "Cloud Run deployment",
      "Interactive development assistance",
    ],
    featuresTire: [
      {
        name: "React component creation",
        isBasic: true,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "SpringBoot API development",
        isBasic: true,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "Automated containerization",
        isBasic: false,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "Cloud Run deployment",
        isBasic: false,
        isPro: true,
        isEnterprise: true,
      },
      {
        name: "Interactive development assistance",
        isBasic: false,
        isPro: false,
        isEnterprise: true,
      },
    ],
    tierFeatures: {
      Basic: [
        "max number of conversations: 10",
        "max number of edits per conversation: 10",
        "max generated tokens per conversation: 50k",
        "max overall generated tokens: 150k",
      ],
      Pro: [
        "max number of conversations: 100",
        "max number of edits per conversation: 50",
        "max generated tokens per conversation: 125k",
        "max overall generated tokens: 375k",
      ],
      Enterprise: [
        "max number of conversations: unlimited",
        "max number of edits per conversation: unlimited",
        "max generated tokens per conversation: unlimited",
        "max overall generated tokens: unlimited",
      ],
    },
    pricing: {
      Basic: 10.99,
      Pro: 19.99,
      Enterprise: "Personal agreement",
    },
  },
} as const;

export const ALLOWED_PRODUCTS_TO_PURCHASE: AllowedProductNames[] = [
  "Nexbot",
  "Nexcode",
];

export const containerVariants = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};

export const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut",
    },
  },
};

export const ALLOWED_PRODUCTS_NAMES_MAPPING: Map<
  AllowedProductNames,
  keyof typeof PRODUCTS_CONFIG
> = new Map([
  ["Nexbot", "NEXBOT"],
  ["Nexcode", "NEXCODE"],
]);
